import { useCallback, useContext } from 'react';
import COOKIES from '~/constants/cookies';
import TradeContext from '~/context/common/TradeContext';
import SearchContext from '~/context/srp/SearchContext';
import { BrowserCookies } from '~/utilities';

export default function useHandleTradeOnPricingFailure() {
  const {
    tradeInfoFromApis: { data: tradeInfoFromApis }
  } = useContext(SearchContext);
  const {
    setSelectedTrade,
    trades: { data: trades }
  } = useContext(TradeContext);

  return useCallback(
    (controller: AbortController) => {
      if (trades.length <= 1 || controller.signal.aborted) return;

      const selectedTrade =
        trades.find(trade => trade.id === tradeInfoFromApis.acquisitionName) ??
        null;
      setSelectedTrade(selectedTrade);

      if (selectedTrade) {
        BrowserCookies.set(COOKIES.preferredTrade, selectedTrade.id, {
          expires: 365
        });
      }
    },
    [setSelectedTrade, tradeInfoFromApis.acquisitionName, trades]
  );
}
